import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconInfo: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3346 2.0002H7.6656C4.26803 2.0002 2.0006 4.43279 2.0006 7.9162V16.0842C2.0006 19.5709 4.26197 22.0002 7.6656 22.0002H16.3336C19.7382 22.0002 22.0006 19.5709 22.0006 16.0842V7.9162C22.0006 4.4297 19.7384 2.0002 16.3346 2.0002ZM7.6656 3.5002H16.3346C18.8851 3.5002 20.5006 5.23516 20.5006 7.9162V16.0842C20.5006 18.7654 18.885 20.5002 16.3336 20.5002H7.6656C5.11536 20.5002 3.5006 18.7655 3.5006 16.0842V7.9162C3.5006 5.23857 5.12094 3.5002 7.6656 3.5002ZM11.9999 7.4543C12.4141 7.4543 12.7499 7.79008 12.7499 8.2043C12.7499 8.58399 12.4677 8.89779 12.1017 8.94745L11.9899 8.9543C11.5757 8.9543 11.2399 8.61851 11.2399 8.2043C11.2399 7.8246 11.5221 7.51081 11.8881 7.46114L11.9999 7.4543ZM11.9899 10.6271C12.3696 10.6271 12.6834 10.9093 12.7331 11.2753L12.7399 11.3771V15.7961C12.7399 16.2103 12.4041 16.5461 11.9899 16.5461C11.6102 16.5461 11.2964 16.2639 11.2467 15.8979L11.2399 15.7961V11.3771C11.2399 10.9629 11.5757 10.6271 11.9899 10.6271Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconInfo;
